import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
  }

  postUser(user: User) {
    return this.httpClient.post<User>(this.baseUrl + 'users', user);
  }

  postServiceAccount(json: string, projectName: string) {
    const body = { json: json, projectName: projectName };
    return this.httpClient.post(this.baseUrl + 'userServiceAccounts/', body);
  }

  putServiceAccount(id: any, json: string, projectName: string) {
    const body = { json: json, projectName: projectName, id: id };
    return this.httpClient.put(this.baseUrl + 'userServiceAccounts/' + id, body);
  }

  deleteServiceAccount(id: any) {
    const body = { id: id };
    return this.httpClient.put(this.baseUrl + 'userServiceAccounts/delete/' + id, body);
  }

  deleteAccount() {
    return this.httpClient.delete(this.baseUrl + 'users/DeleteAccount/');
  }

  getServiceAccounts() {
    return this.httpClient.get(this.baseUrl + 'userServiceAccounts/');
  }

  getServiceAccount(id: any) {
    return this.httpClient.get(this.baseUrl + 'userServiceAccounts/' + id);
  }

  getUserSubscriptionPlan() {
    return this.httpClient.get(this.baseUrl + 'users/getUserSubscriptionPlan/');
  }

  signIn(user: any) {
    return this.httpClient.post<any>(this.baseUrl + 'auth/', { idToken: user.idToken, userId: user.id, profileImage: user.photoUrl });
  }
}

interface User {
  GoogleId: string;
  Fullname: string;
  ProfileImage: string;
  LastLoggedIn: Date;
}
